import { Center, Pagination, PaginationProps } from "@mantine/core";

const CustomPagination = (props: PaginationProps) => {
  if (props.total <= 1) {
    return <></>;
  }
  return (
    <Center>
      <Pagination
        color={'var(--mantine-primary-color-9)'}
        pt={'lg'}
        pb={'lg'}
        {...props}
        value={(props.value ?? 0) + 1}
      />
    </Center>
  )
}

export default CustomPagination;